module.exports = __webpack_public_path__ + "static/img/fm4.279d6c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm4.jpg
// module id = bDHp
// module chunks = 1